import { baseCRUDAPI } from './base';

export default class EventTypes extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'TypeEvent');
  }
}
